import { render, staticRenderFns } from "./AdminPageHeaderView.vue?vue&type=template&id=4d36e34c&"
import script from "./AdminPageHeaderView.vue?vue&type=script&lang=js&"
export * from "./AdminPageHeaderView.vue?vue&type=script&lang=js&"
import style0 from "./AdminPageHeaderView.vue?vue&type=style&index=0&id=4d36e34c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports